import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/reports/dealer-payouts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/reports/dealer-payouts', data, { responseType: 'arraybuffer' })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTran = (Options = {}) => {
  return httpClient
    .get('/api/transaction-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { store, get, getTran }
